import {Component, OnInit} from '@angular/core';
import {ROLES} from '../../../model';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  standalone: false
})
export class MainPageComponent implements OnInit {
  private roles!: ROLES[];

  viewEventi!: boolean;
  viewReservation!: boolean;
  viewMdr!: boolean;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    let storageRoles = this.userService.getCurrentUserRoles();
    if (storageRoles) {
      this.roles = storageRoles;
      this.getRole();
    }
  }

  private getRole() {
    if (this.roles.includes(ROLES.ADMIN)) {
      this.viewEventi = true;
      this.viewReservation = true;
      this.viewMdr = true;
    } else if (this.roles.includes(ROLES.OPERATORE)) {
      this.viewEventi = false;
      this.viewReservation = true;
      this.viewMdr = false;
    }
  }
}
